enum SIGNUP_ACTIONS {
    REACTIVATION = 'reactivation',
    REPURCHASE = 'repurchase',
    PAYMENT_CHANGE = 'payment',
}

export default SIGNUP_ACTIONS
